export default __webpack_public_path__ + "images/close.cf97ef894629543eb0e78cba2b536c0d.svg";